import styled from "styled-components";
import fipayFonts from "../../../theme";
import { colors } from "../../../theme/color";

interface DropdownContentProps {
  isOpen: boolean;
}

export const PaymentLinkContainer = styled.div`
  width: 100%;
  position: fixed;
  height: 80px;
  background-color: #ffffff;
  z-index: 9999;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
  @media only screen and (max-width: 767px) {
    /* width: 50%; */
    height: 3.125rem;
    border-bottom: 1px solid ${colors.general.brightGray};
    background: ${colors.White};
    box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
    width: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* width: 100%; */
  }
`;

export const PaymentLinkSubtitle = styled.div`
  width: 75%;
  display: flex;
  margin-left: auto;
  align-items: center;
  align-content: center;
  padding-top: 20px;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    margin-left: 1rem;
  }

  @media only screen and (max-width: 767px) {
    width: 85%;
    height: 3rem;
    padding: 0 1rem 0 1rem;
    margin: 0;
    justify-content: space-between;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* width: 100%; */
    margin-left: 1rem;
  }
`;

export const IntegrationSupportCon = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  border: 1px solid #e8eaed;
  padding: 10px;
  border-radius: 5px;
  color: ${colors.BLACK};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  img {
    margin-right: 7px;
  }
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    span {
      font-size: 0.7rem;
    }
  }
`;

export const ApiDoc = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
  align-content: center;
  border: 1px solid #e8eaed;
  border-radius: 5px;
  padding: 10px;
  color: ${colors.BLACK};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};

  img {
    margin-right: 7px;
  }
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    span {
      font-size: 0.7rem;
    }
  }
`;

export const TestMode = styled.div`
  width: 13%;
  margin-left: 20px;
  margin-right: -30px;
  display: flex;
  align-items: center;
  align-content: center;
  color: ${colors.BLACK};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};

  img {
    margin-right: 7px;
  }
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    span {
      font-size: 0.7rem;
    }
  }
`;

export const NotificationBar = styled.div`
  margin-left: 1rem;
  display: flex;
  align-items: center;
  align-content: center;
  border: 1px solid #e8eaed;
  border-radius: 50%;
  background-color: #e8eaed;
  padding: 4px;
  @media only screen and (max-width: 767px) {
    align-self: center;
    padding: 0.4rem;
    margin: 0;
    background-color: #f7f7f7;
  }
  @media only screen and (max-width: 768px) {
    margin-left: 5rem;
  }

  @media only screen and (max-width: 1024px) {
    /* margin-left: 1rem;
    margin-right: 0.5rem; */
  }

  @media (min-width: 425px) {
    margin-right: 0.01rem;
  }

  @media (min-width: 375px) {
    margin-left: 3rem;
  }
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
  @media only screen and (max-width: 1024px) {
    margin: 0;
  }

  @media (min-width: 1680px) {
    padding-right: 140px;
  }

  @media (min-width: 375px) {
    margin-left: 1rem;
  }
`;

export const ProfilePicCon = styled.div`
  /* padding-left: 10px; */
  @media only screen and (max-width: 767px) {
    padding: 0;
    width: 2rem;
    height: 2rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }
`;

export const NameSubtitle = styled.div`
  /* padding-left: 15px; */
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }
`;

export const NameTag = styled.div`
  padding-left: 10px;
  color: ${colors.BLACK};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
`;

export const EmailTag = styled.div`
  padding-left: 10px;
  padding-top: 10px;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.GRAY};
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }
  @media only screen and (max-width: 768px) {
    font-size: 0.5rem;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 0.8rem;
  }
`;

export const DividerOne = styled.div`
  border-left: 2px solid #e8eaed;
  height: 47px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    /* margin-left: 1.5rem; */
    /* margin-right: 0.5rem; */ */
  }
  @media only screen and (max-width: 1024px) {
    margin-right: -2rem; */

  }
  @media only screen and (max-width: 1440px) {
    margin-right: -2rem; */

  }
`;

export const DividerTwo = styled.div`
  border-left: 2px solid #e8eaed;
  height: 46px;
  @media only screen and (max-width: 767px) {
    margin: 0;
    height: 2.375rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin: 0;
  }

  @media (min-width: 425px) {
    /* margin-right: 0.5rem;
    margin-left: 0.5rem; */
    margin: 0;
  }
`;

export const ArrowDownImg = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 40px;

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
  @media only screen and (max-width: 1024px) {
    margin: 0;
    margin-left: 50px;
  }

  @media (min-width: 425px) {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  @media (min-width: 375px) {
    /* margin-left: 2rem; */
    margin-right: 2rem;
  }

  @media (min-width: 320px) {
    margin-left: 1rem;
    margin-right: 0.4rem;
  }
`;
export const MobileMenu = styled.div`
  display: none;
  @media only screen and (max-width: 767px) {
    display: flex;
    align-items: center;
  }
`;
export const MobileComponents = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 1rem;
  @media only screen and (max-width: 767px) {
    display: flex;
    margin-left: auto;
    align-items: center;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    gap: 0.5rem;
  }
`;
export const HamburgerIconWrapper = styled.div`
  @media only screen and (max-width: 767px) {
    cursor: pointer;
  }
`;
export const DropdownContent = styled.div<DropdownContentProps>`
  @media only screen and (max-width: 767px) {
    display: ${(props) => (props.isOpen ? "block" : "none")};
    background-color: #fff;
  }
`;

export const DropdownAccContainer = styled.div`
  position: absolute;
  top: 50px;
  width: 100%;
`;
